import { render, staticRenderFns } from "./SailingSchedule.vue?vue&type=template&id=bf2a8fe0"
import script from "./SailingSchedule.vue?vue&type=script&lang=js"
export * from "./SailingSchedule.vue?vue&type=script&lang=js"
import style0 from "./SailingSchedule.vue?vue&type=style&index=0&id=bf2a8fe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports